module.exports = __webpack_public_path__ + "img/product-kredit-pemilikan-rumah-old.bdce746e.jpeg";